module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.getBlockModifiers()
  }, [(_vm.showSlider) ? _c('slider', {
    class: [_vm.block + '-buttons'],
    attrs: {
      "data": {
        slider: _vm.slider,
        leftLabel: _vm.hasLabels ? _vm.data.labels[0] : 'Mobile',
        rightLabel: _vm.hasLabels ? _vm.data.labels[1] : 'Desktop'
      }
    },
    on: {
      "slide": _vm.slide
    }
  }) : _vm._e(), _vm._v(" "), _c('video', {
    class: [_vm.block + '-video', {
      'm-clickable': !_vm.autoplay,
      'm-fixedHeight': _vm.showSlider
    }],
    attrs: {
      "src": _vm.src + '#t=0.01',
      "playsinline": "",
      "preload": "auto"
    },
    on: {
      "click": _vm.toggleVideo,
      "mouseover": _vm.mouseoverVideo,
      "ended": _vm.endOfVideo
    }
  }), _vm._v(" "), (!_vm.autoplay) ? _c('button-block', {
    class: [_vm.block + '-controlButton', {
      'm-visible': !_vm.autoplay && !_vm.playing
    }],
    attrs: {
      "id": "play",
      "icon": "play"
    },
    nativeOn: {
      "click": function($event) {
        _vm.playVideo($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('button-block', {
    class: [_vm.block + '-controlButton'],
    attrs: {
      "id": "pause",
      "icon": "pause"
    },
    nativeOn: {
      "click": function($event) {
        _vm.pauseVideo($event)
      }
    }
  }), _vm._v(" "), _c('button-block', {
    class: [_vm.block + '-controlButton', {
      'm-visible': !_vm.autoplay && !_vm.loop && _vm.videoEnded
    }],
    attrs: {
      "id": "playAgain",
      "icon": "replay"
    },
    nativeOn: {
      "click": function($event) {
        _vm.playAgain($event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-668bfec7","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/combinedBlocks/Video.vue
// module id = 513
// module chunks = 0